import { ref, reactive } from 'vue'

// Form verileri
export const form = reactive({
  suggestion: '',
  currentImageUrl: '',
  currentVideoUrl: '',
  currentText: '',
  priority: 3,
})

// Hata durumları
export const errors = reactive({
  suggestion: '',
  currentImageUrl: '',
  currentVideoUrl: '',
  currentText: '',
})

// Yükleme ve hata durumları
export const isSubmitting = ref(false)
export const imageLoadError = ref(false)
